import { IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { IPermiso } from "../model";

export default class PermisoService extends ServiceBase {
  all = () : Promise<IResponse<IPermiso[]>> => 
    this.GetFetch<IResponse<IPermiso[]>>('entity/permiso/all', {});
}